import React from "react";
import "./Card.css";
import DefaultImage from "../ImageData/Images/default.png";

const Card = (props) => {
  const { card, handleChoice, flipped, disabled } = props;

  const handleClick = () => {
    if (!disabled) {
      handleChoice(card);
    }
  };
  return (
    <div className="card" key={card.id}>
      <div className={flipped ? "flipped" : ""}>
        <img
          className="front"
          src={card.src}
          alt="card front"
          onClick={handleClick}
        />
        <img
          className="back"
          src={DefaultImage}
          alt="card back"
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default Card;
